import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, CardContent, Typography } from '@mui/material';
import { PartialIcon, SegmentTooltip } from '../../../App/components/core';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import { getAsLongDate, getAsStartAndEndTimeFormat } from '../../../../common-client2/src/services/ukgDateTime';
import { hasTransfer } from '../../../auxilaries';
import { getShiftCardClass } from './ShiftCardWithTooltip.service';
import { ShiftSegmentTypeName } from '../../../Enums';
import './ShiftCardWithTooltip.scss';

const displayDurationInHours = (segment) => `[${(new Date(segment.endDateTime) - new Date(segment.startDateTime)) / 1000 / 60 / 60}]`;

const ShiftCardWithTooltip = ({
    shift,
    partialShift,
    timeOffRequest,
    isLargeShiftTimeText = false,
    actionType,
    isApproved,
    isVto = false,
    tooltipPlacement="left",
    isDisplaySegmentInfos = false,
    selectedAssignmentName,
}) => {
    const { t } = useTranslation('common');

    const displaySegmentInfos = (segments) => segments.map(x => 
        <span 
            className={'segment-infos'}
            key={`segment-infos-${x.id}`}
        >
            <span className={'segment-info-time'}>
                {
                    `${getAsStartAndEndTimeFormat(x.startDateTime, x.endDateTime)} ${displayDurationInHours(x)}`
                } 
                {
                    x.type === ShiftSegmentTypeName.TRANSFER_SEGMENT 
                        ? <CompareArrowsIcon className="segment-info-transfer" /> 
                        : ""
                }
            </span>
            {` ${t(`SegmentType.${x.type}`)}`}
        </span>);

    const shiftCardClass = getShiftCardClass(actionType, isApproved);
    const isPartial = !!partialShift;
    const shiftToOffer = isPartial ? partialShift : shift;
    const firstSegmentPrimaryJob = shiftToOffer?.segments.find(x => x.type !== ShiftSegmentTypeName.BREAK_SEGMENT).orgJobRef.qualifier;
    const shiftTimeTextClass = isLargeShiftTimeText ? 'shiftTimeTextLarge' : 'shiftTimeText';

    return (
        <SegmentTooltip
            data={shiftToOffer}
            isVto={isVto}
            isPartial={isPartial}
            originalShift={shift}
            placement={tooltipPlacement}
            timeOffRequest={timeOffRequest}
            selectedAssignmentName={selectedAssignmentName}
        >
            <div style={{ width: '100%' }}>
                <Button className='transparentButtonNoPadding'>
                    <Card className={shiftCardClass}>
                    <CardContent className='fixPadding'>
                            <div>
                                <Typography className={shiftTimeTextClass}>
                                    {getAsStartAndEndTimeFormat(shiftToOffer.startDateTime, shiftToOffer.endDateTime)}
                                    {hasTransfer(shift) ? ' (X) ' : ' '}
                                    {`(${getAsLongDate(shiftToOffer.startDateTime)})`}
                                </Typography>
                            <Typography className='primaryJobText'>
                                    {firstSegmentPrimaryJob}
                                </Typography>
                            </div >
                            <div className="margin-right-auto" />
                            {hasTransfer(shift) && <div className="transfer-icon-wrapper"><CompareArrowsIcon /></div>}
                            {isPartial && <PartialIcon />}
                        </CardContent >
                    </Card >
                </Button >
                <Typography >
                    {isDisplaySegmentInfos ? displaySegmentInfos(shiftToOffer.segments) : ""}
                </Typography>
            </div >
        </SegmentTooltip >
    )
};

export default ShiftCardWithTooltip;